import { useEffect, useState } from "react";
import { useQuery } from "convex/react";

import { api } from "@/../convex/_generated/api";
import type { Id } from "@/../convex/_generated/dataModel";
import { useSession } from "@/core/auth/useSession";
import { useModeDemo } from "@/core/demo";
import { abonnerAuxVentes } from "@/core/demo/argent";
import { leClassement } from "@/core/demo/classement";

import type { ClassementData } from "./ClassementOnglet";

/**
 * Le classement de la semaine — UN lecteur pour l'onglet et la pastille de rang.
 *
 * Hors démo : `classement.semaine` (Convex), tel quel. En démo : l'équipe
 * fictive de `core/demo/classement.ts`, relue à chaque vente de la prise — les
 * vrais chatteurs ne passent jamais à l'image (Kayla, 15-10-2026).
 */
export function useClassementSemaine(accountId: Id<"accounts"> | null): ClassementData | null | undefined {
  const enDemo = useModeDemo();
  const reel = useQuery(api.classement.semaine, !enDemo && accountId ? { accountId } : "skip");
  const { user } = useSession();
  const [, relire] = useState(0);
  useEffect(() => {
    if (!enDemo) return;
    return abonnerAuxVentes(() => relire((n) => n + 1));
  }, [enDemo]);

  if (!enDemo) return reel;
  if (!user) return undefined;
  return leClassement({
    workosUserId: user.workosUserId,
    nom: user.firstName ?? user.email.split("@")[0] ?? "Moi",
    avatarUrl: user.profilePictureUrl,
  });
}
